// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"cb89a400","645":"ebd55a45"}[chunkId] + ".chunk.js";
};